<template>
  <normal-layout
      :title="'我的钱包'"
      :content-background-color="'#F0F0F4'"
      :show-bottom-border="false"
  >
    <template #left-btn>
      <left-button/>
    </template>
    <template #right-btn>
      <p class="right-button" @click="onParticulars">明细</p>
    </template>
    <template #content>
      <div class="index-container">
        <div class="content-container">
          <div class="balance-container" :class="{ 'expand-container' : hasFailure }">
            <div class="wallet-balance-item" :style="{ height: hasFailure ? '1.8rem' : '1.6rem' }">
              <p class="balance-title">{{ walletTitle }}</p>
              <p class="balance">{{ walletDesc }}</p>
              <div class="apply-deposit" @click="withdrawApply">{{ applyDesc }}</div>
              <p class="reason" v-if="hasFailure" @click="showReasonDialog=true">查看原因</p>
            </div>
            <div class="vertical-separator" :class="{ 'expand' : hasFailure }"></div>
            <div class="account-balance-item" :style="{ height: hasFailure ? '1.8rem' : '1.6rem' }">
              <p class="balance-title">{{ balanceTitle }}</p>
              <p class="balance">{{ balanceDesc }}</p>
              <div class="deposit-account" @click="withdrawAccount">提现到卡</div>
            </div>
          </div>

          <div class="link-container">
            <ul class="link-list">
              <li class="link-item" @click="bankList">
                <p class="link-name">银行卡</p>
                <img class="link-img" src="../../assets/images/wallet/more.png" alt/>
              </li>
              <li class="link-item">
                <p class="link-name">关联手机号</p>
                <div class="phone-container">
                  <p class="phone">{{ mobile }}</p>
                </div>
              </li>
            </ul>
          </div>
          <p class="hint">{{ notice }}</p>
        </div>
        <bank-identity/>
      </div>
      <popup v-model="showReasonDialog" position="center" :style="{ width: '80%', borderRadius: '.1rem' }"
             :safe-area-inset-bottom="true"
             :close-on-popstate="true" :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, .5)'}">
        <div class="d-reason">
          <p>审核结果</p>
          <label>{{ `原因：${walletData.remark}` }}</label>
          <span @click="showReasonDialog = false">我知道了</span>
        </div>
      </popup>
    </template>
  </normal-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import NormalLayout from '../../components/actionbar/BasicLayout'
import LeftButton from '../../components/actionbar/TopLeftButton'
import BankIdentity from './components/BankIdentity'
import { Toast, Popup } from 'vant'
import { queryWalletInfo } from '@/request/api.encryptor'

export default {
  name: 'Wallet',
  components: {
    NormalLayout,
    LeftButton,
    BankIdentity,
    Popup
  },
  props: {
    walletInfo: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      walletData: this.walletInfo,
      // 接口获取到的type
      type: '00',
      acctAvailBal: '0', // 钱包，通宝余额,
      amount: '0', // 可提现金额
      cashAmt: '0', // 最大可申请提现金额,
      endTime: '', // 授权截止时间
      remark: '', // 备注（比如审核未通过原因等)
      status: null, // 授权状态(0:待审核，1:审核通过,2:驳回，3:已提现。空/其他:未审核)
      mobile: '****', // 手机号

      applying: false, // 申请提现中
      withdrawing: false, // 提现到卡中
      showReasonDialog: false,

      applyingTimer: null,
      withdrawTimer: null,
    }
  },
  created() {
    window.JD_Resume = () => {
      this.getWalletInfo()
    }
  },
  mounted() {
    this.setWalletInfo()
    this.$nextTick(() => {

    })
  },
  methods: {
    // 查询钱包信息
    getWalletInfo() {
      queryWalletInfo()
          .then(res => {
            const { code, info = {}, msg = '' } = res || {}
            if (code === 0) {
              this.walletData = info
              this.setWalletInfo()
            } else if (code === 450) {
              // 用户未开户
              this.bus.$emit('changeWallet', 1)
            } else if (code === 443) {
              // 请联系管理员
              this.bus.$emit('changeWallet', 3)
            } else {
              Toast.fail(msg)
            }
          })
          .catch(msg => {
            Toast.fail(msg)
          })
    },
    setWalletInfo() {
      const {
        acctAvailBal = 0,
        amount = 0,
        cashAmt = 0,
        endTime = '',
        remark = '',
        status = 0,
        mobile = ''
      } = this.walletData || {}
      this.acctAvailBal = acctAvailBal
      this.amount = Number(amount)
      this.cashAmt = Number(cashAmt)
      // 可提现金额不可以大于最大可申请提现金额
      if (this.amount > this.cashAmt) {
        this.amount = this.cashAmt
      }
      this.endTime = endTime
      this.remark = remark
      this.status = status
      this.mobile = mobile
      // 转换手机号码
      this.convertPhoneString()
    },
    convertPhoneString() {
      if (this.mobile && this.mobile.length > 7) {
        let startString = this.mobile.slice(0, 3)
        let endString = this.mobile.slice(7)
        this.mobile = startString + '****' + endString
      }
    },
    // 明细
    onParticulars() {
      this.$JD.nativeRouter({
        url: '/wallet/particulars'
      })
    },
    withdrawApply() {
      if (this.applying) {
        return
      }
      this.applying = true
      let walletBalance = Number.parseFloat(this.acctAvailBal)
      if (walletBalance < 0.01) {
        this.applying = false
        Toast('钱包余额为0')
        return
      }
      let cashApply = Number.parseFloat(this.cashAmt)
      if (cashApply < 0.01) {
        this.applying = false
        Toast('可申请提现余额为0')
        return
      }
      this.$JD.nativeRouter({
        url: '/wallet/withdrawApply',
        query: {
          acctAvailBal: walletBalance,
          cashAmt: cashApply,
        }
      })
      this.applyingTimer = setTimeout(() => {
        this.applying = false
        clearTimeout(this.applyingTimer)
      }, 1000)
    },
    withdrawAccount() {
      if (this.withdrawing) {
        return
      }
      this.withdrawing = true

      let cash = Number.parseFloat(this.amount)
      if (cash < 0.01) {
        this.withdrawing = false
        Toast('余额不足，不可操作')
        return
      }
      this.$JD.nativeRouter({
        url: '/wallet/withdrawAccount',
        query: {
          amount: cash
        }
      })
      this.withdrawTimer = setTimeout(() => {
        this.withdrawing = false
        clearTimeout(this.withdrawTimer)
      }, 1000)
    },
    bankList() {
      this.$JD.nativeRouter({
        url: '/wallet/banks'
      })
    },
    changePhone() {
      // this.$JD.app_router('Wallet.RelevantPhone')
    }
  },
  computed: {
    ...mapGetters(['user']),
    hasFailure() {
      return this.status === 2
    },
    walletTitle() {
      return '钱包余额(¥)'
    },
    balanceTitle() {
      return '可提现金额(¥)'
    },
    walletDesc() {
      return '¥' + this.acctAvailBal
    },
    balanceDesc() {
      return '¥' + this.amount
    },
    applyDesc() {
      if (this.status === 2) {
        return '重新申请'
      } else if (this.status === 0) {
        return '申请中'
      } else {
        return '申请提现'
      }
    },
    notice() {
      let frontString = '*本手机号是'
      let behindString = '支付及提现相关操作的唯一通道，请谨慎处理，如需修改请确保新的手机号真实有效'
      return frontString + '钱包' + behindString
    }
  }
}
</script>

<style lang="scss">

.right-button {
  font-size: 0.173rem;
  color: #525252;
}

.index-container {
  background-color: #f0f0f0;
  font-family: SourceHanSansCN-Normal;

  .content-container {
    margin-top: 0.1rem;
    padding: 0 0.1rem;

    .expand-container {
      height: 2.4rem !important;
    }

    .balance-container {
      height: 2.1rem;
      padding: 0.25rem 0.2rem;
      background: linear-gradient(180deg, rgba(234, 205, 118, 1) 0%, rgba(234, 189, 118, 1) 100%);
      display: flex;
      align-items: center;
      border-radius: 0.1rem;

      .vertical-separator {
        width: 1px;
        flex-shrink: 0;
        background-color: #ffffff;
        height: 1.5rem;
      }

      .expand {
        height: 1.8rem;
      }

      .wallet-balance-item, .account-balance-item {
        height: 1.6rem;
        color: #ffffff;
        flex: 1;

        .balance-title {
          font-size: 0.2rem;
          text-align: center;
          height: 0.2rem;
        }

        .balance {
          font-family: SourceHanSansCN-Medium;
          height: 0.347rem;
          line-height: 0.347rem;
          text-align: center;
          margin-top: 0.2rem;
          font-size: 0.347rem;
          font-weight: 500;
          max-width: 2.18rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .apply-deposit, .deposit-account {
          margin: 0.4rem auto 0;
          width: 1.2rem;
          height: 0.37rem;
          line-height: 0.37rem;
          font-size: 0.2rem;
          text-align: center;
          border-radius: 0.185rem;
          border: 1px solid #ffffff;
        }

        .reason {
          color: #b86216;
          font-size: 0.16rem;
          text-align: center;
          margin-top: 0.1rem;
        }
      }
    }
  }

  .link-container {
    margin-top: 0.1rem;

    .link-list {
      background-color: #ffffff;
      border-radius: 0.1rem;

      .link-item {
        padding: 0.25rem 0.15rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f4;

        .link-name {
          font-size: 0.2rem;
          color: #525252;
        }

        .phone-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1.5rem;

          .phone {
            font-size: 0.2rem;
            max-width: 1.4rem;
            text-align: center;
            color: #525252;
          }
        }

        .link-img {
          width: 0.1rem;
          height: 0.2rem;
        }
      }
    }
  }

  .hint {
    padding: 0.2rem;
    color: #8b8b8b;
  }
}

.d-reason {
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: .36rem .2rem;

  p {
    color: #333333;
    font-size: .24rem;
  }

  label {
    color: #6D6D6D;
    font-size: .173rem;
    line-height: .24rem;
    margin-top: .287rem;
  }

  span {
    width: 2.667rem;
    height: .507rem;
    margin-top: .8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: .2rem;
    background: #EC2B24;
    border-radius: .253rem;
  }
}
</style>
